import N8nDataTableServer from './N8nDataTableServer.vue';

export default N8nDataTableServer;
export type { TableOptions, TableHeader } from './N8nDataTableServer.vue';
